import { CheckCircle } from "@mui/icons-material";
import { ListItemButton, ListItemIcon, ListItemText, Tooltip } from "@mui/material";
import React from "react";

interface IFilterByButtonProps {
  label: string;
  tooltip?: string;
  hasAppliedValues: boolean;
  selected: boolean;
  onClick: React.MouseEventHandler<HTMLDivElement>;
}

export const FilterByButton = (props: IFilterByButtonProps) => {
  const { label, tooltip, hasAppliedValues, selected, onClick } = props;

  return (
    <Tooltip title={tooltip} placement="left">
      <ListItemButton
        role={undefined}
        onClick={onClick}
        selected={selected}
        dense
        sx={(theme) => ({
          "&.Mui-selected": {
            background: theme.palette.common.white,
            color: theme.palette.text.primary,
          },
          "&.Mui-selected:hover": {
            background: theme.palette.common.white,
          },
          "&.Mui-selected .MuiListItemIcon-root": {
            color: theme.palette.primary.main,
          },
          "&:hover": {
            background: theme.palette.grey[300],
          },
        })}
      >
        <ListItemIcon>
          <CheckCircle
            sx={{
              visibility: hasAppliedValues ? "visible" : "hidden",
            }}
          />
        </ListItemIcon>
        <ListItemText
          primary={label}
          sx={{
            overflowX: "hidden",
            overflowWrap: "anywhere",
          }}
        />
      </ListItemButton>
    </Tooltip>
  );
};
